import { Box, Stack } from "@mui/system"

import { NewsCardTab } from "../components/NewsCardTab"
import { useAppLocalization } from "../../localization/components/AppLocalizationProvider"
import { RoadmapCardTab } from "../components/RoadmapCardTab"
import { StandardTabs } from "../../../shared/components/tabs/StandardTabs"
import NewFeatures from "../components/NewFeatures"
import { UserType } from "../../login/loginTypes"
import { useAppSelector } from "../../store/storeHooks"
import { selectUserType } from "../../login/loginSelectors"

export const NewsPage = () => {
    const { l10n } = useAppLocalization()
    const actualUserType = useAppSelector(selectUserType)
    const isUser = actualUserType === UserType.USER
    const tabs = [
        {
            label: l10n.getString("news-gopay"),
            component: <NewsCardTab />,
        },
    ]
    if (isUser) {
        tabs.push({
            label: l10n.getString("news-new-features"),
            component: <NewFeatures />,
        })
    } else {
        tabs.push({
            label: l10n.getString("news-roadmap"),
            component: <RoadmapCardTab />,
        })
    }

    return (
        <Box sx={{ width: "100%", pt: "1rem" }}>
            <Stack position="relative">
                <StandardTabs tabs={tabs} />
            </Stack>
        </Box>
    )
}
